import styled from "styled-components";
import heroBackground from "../../../assets/imgs/heroBackground.png";

export const Container = styled.div`
  display: flex;
  background-image: url("${heroBackground}");
  background-position: right;
  background-size: contain;
  background-repeat: no-repeat;
  height: 770px;
  padding: 0 200px;
  align-items: center;
  background-color: #ececec;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: #696969;
`;

export const Heading = styled.div`
  display: inline;
  width: 607px;
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 76px;
  margin: 15px 0 27px 0;
  color: ${({ yellow }) => (yellow ? "#ffbc01" : "#0d263b")};
`;

export const Button = styled.button`
  width: 176px;
  height: 55px;
  background: #006766;
  border-radius: 3px;
  border: none;
  color: #fff;
  transition: all 0.3s;
  :active {
    transform: scale(0.95);
  }
`;
